import { action, observable } from 'mobx'

import Ds from './ds'

class ShippingTypes {
  @observable data = []

  @observable ds = new Ds()

  @action loadAllShippingTypes() {
    this.ds.query(`{ shippingTypes(hash: "${ localStorage.getItem('userHash') }") { id name } }`, (data) => {
      this.data = data.shippingTypes
    })
  }

  @action newShippingType(name) {
    this.ds.query(`mutation { addShippingType(name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllShippingTypes()
    })
  }

  @action updateShippingType(id, name) {
    this.ds.query(`mutation { updateShippingType(id: ${ id }, name: "${ name }", hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllShippingTypes()
    })
  }

  @action deleteShippingType(id) {
    this.ds.query(`mutation { deleteShippingType(id: ${ id }, hash: "${ localStorage.getItem('userHash') }") { id } }`, (data) => {
      this.loadAllShippingTypes()
    })
  }
}

export default new ShippingTypes



// WEBPACK FOOTER //
// ./src/stores/shippingtypes.js